import { Button, CircularProgress, Stack } from '@mui/material';
import { useToasterContext } from '@src/context/Toaster';
import { AlertType } from '@src/lib/types/toaster';
import Config from "@src/utils/api/config";
import React, { useMemo } from 'react';
import { useServices } from '../hooks';
import { useHomePageEditorContext } from '../provider';
import Input from './input';
import NewMailMask from './mask';
import { useCreateContext } from './provider';

import Iconify from '@src/components/iconify';
import {
  StyledContainer,
  StyledStackRow,
  StyledUploadBox,
  styles
} from './styles.css';

function Description() {
  const { uploadImage } = useServices();
  const { triggerOpen } = useToasterContext();

  const { container, setContainer } = useHomePageEditorContext();
  const { state, error, onDispatch } = useCreateContext();

  const handleFileChange = (type: string) => (event: any) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 3 * 1024 * 1024) {
        triggerOpen({
          type: AlertType.error,
          title: "Failed",
          message: "File size must be less than 3MB",
        });
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", type);
      uploadImage.mutate(formData);
    }
  };

  const label= useMemo(() => {
    switch(container){
      default:
      case "subBlock1": 
        return "Container 1 Text:";
      case "subBlock2": 
        return "Container 2 Text:";
      case "subBlock3": 
        return "Container 3 Text:";
    }
  },[container]);

  React.useEffect(() => {
    if(uploadImage.data && uploadImage.isSuccess){
      onDispatch(uploadImage.data.type)(`${Config.APP_CDN_URL}/${uploadImage.data.result.filePath}`);   
    }
  },[uploadImage.isSuccess, uploadImage.data, onDispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <StyledContainer>
      <Button sx={styles.btn_close} onClick={() => setContainer("")}>
        <Iconify  icon={'mdi:close'} width={25} />
      </Button>
      <StyledStackRow 
        sx={{
          width: "100%",
          flexDirection: {
            xl: "column",
            lg: "column",
            md: "column",
            sm: "column",
            xs: "column",
          },
          gap: {
            xl: "1rem",
            lg: "1rem",
            md: "3rem",
            sm: "1rem",
            xs: "1rem",
          }}} mt={2}>
        <Stack sx={{flexDirection: "row", alignItems: "center"}}>
          <StyledUploadBox sx={[error.thumbnail && {border: "1px dashed red"}]} >
            <input
              type="file"
              id="image"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange("image")}
            />
            {!state.image && <NewMailMask notes="Recommended size: 440x256px" 
              notes2="(recommended file type eg. .jpg, .png and file size 3mb or less)"/>}
            {uploadImage.isPending && 
              <CircularProgress sx={{position: "absolute"}} />}
            {state.image && 
              <img 
                src={state.image} 
                alt="Selected" 
                style={{ maxWidth: '90%', height: '90%' }} />}
          </StyledUploadBox>
          <Stack width={274}>
            <Button disabled={uploadImage.isPending} onClick={() => {
              document.getElementById('image')?.click();
            }} sx={styles.btn_upload} >UPLOAD IMAGE</Button>
          </Stack>
        </Stack>
        <Stack sx={{width: "100%"}}>
          <Input sx={{mt: 1.4}} 
            label={label}
            labelSx={{
              fontSize: 16,
              fontWeight: "700"
            }}
            inputSx={{
              '& .MuiInputBase-root': {
                width: "auto",
                minHeight: '157px',
              },
              "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
                padding: "12px 14px",           // 👈 Better paragraph feel
              },
              "& .MuiOutlinedInput-input": {
                fontSize: "15px",
                lineHeight: "22px",
                padding: 0,                     // removes default tight padding
              },
            }}
            placeholder='Enter here...'
            error={error.description}
            value={state.description}
            onChange={onDispatch("description")} />
        </Stack>
      </StyledStackRow>
    </StyledContainer>
  );
}

export default Description;